import { isSameDay } from 'date-fns';
import getDateRangeFromNow from './getDateRangeFromNow';

const periodNames = ['lastWeek', 'nextWeek'];

const getPeriodNameByRange = (value) => {
  if (value.length === 0 || (value[0] === null && value[1] === null)) {
    return null;
  }

  return periodNames.reduce((acc, periodName) => {
    const period = getDateRangeFromNow(periodName);
    const isDatesEqual =
      isSameDay(period.dateStart, value[0]) && isSameDay(period.dateEnd, value[1]);

    return isDatesEqual ? periodName : acc;
  }, 'custom');
};

export default getPeriodNameByRange;
